import { StateSchema } from "@/app/providers/StoreProvider";

export const getIsLoading = (state: StateSchema) => state.subscription?.isLoading;
export const getIsSuccess = (state: StateSchema) => state.subscription?.isSuccess;
export const getError = (state: StateSchema) => state.subscription?.error;
export const getIsFetchingDetails = (state: StateSchema) => state.subscription?.isFetchingDetails;
export const getDetails = (state: StateSchema) => state.subscription?.details;
export const getProductsAreLoading = (state: StateSchema) => state.subscription?.productsAreLoading || false;
export const getProductsList = (state: StateSchema) => state.subscription?.productsList || [];
